import api from '../../api/index.js'

const state = {
    
}

const getters = {
    
}

const actions = {

    ShopIndex({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Shop/Index',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    ShopInfo({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Shop/Info',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })

    },
    ShopPost({commit},payload){
        return new Promise((resolve, reject) => {
            api.post('/Shop/Post',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetCurrentShop({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Shop/GetCurrentShop',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetShopByMemberId({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Shop/GetShopByMemberId',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetShopList({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Shop/GetShopList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetCityList({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/Common/GetCityList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js